/**
 * @generated SignedSource<<95849cad8f1c89e86ec0ef061fbb0d77>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type caseGallerySwiper_mediaDataConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly mediaType: {
        readonly name: string;
      } | null | undefined;
      readonly resourceUrl: string | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "caseGallerySwiper_mediaDataConnection";
};
export type caseGallerySwiper_mediaDataConnection$key = {
  readonly " $data"?: caseGallerySwiper_mediaDataConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"caseGallerySwiper_mediaDataConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "caseGallerySwiper_mediaDataConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaDataEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Media",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "resourceType",
                  "value": "Asset"
                }
              ],
              "kind": "ScalarField",
              "name": "resourceUrl",
              "storageKey": "resourceUrl(resourceType:\"Asset\")"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MediaType",
              "kind": "LinkedField",
              "name": "mediaType",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MediaDataConnection",
  "abstractKey": null
};

(node as any).hash = "131004f792add142f0c47950309a50dc";

export default node;
